import { createSlice } from '@reduxjs/toolkit';

export const snowSlice = createSlice({
  name: 'snow',
  initialState: {
    snowFall: false,
  },
  reducers: {
    setSnowFallAction: (state, { payload }) => ({
      ...state,
      snowFall: payload,
    }),
  },
});

export const { setSnowFallAction } = snowSlice.actions;
export const getSnowFall = (state: any) => state.snow.snowFall;

export default snowSlice.reducer;
